import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import JobCardCylinderChild from "./JobCardCylinderChild";

import { Button, Tooltip } from "antd";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList.jsx";
import { EditSetsContainer } from "../../Pages/styledElements.js";
import { Styled } from "../../Pages/pageStyled.js";
import Iconmoon from "../IconsFiles/icon.js";
import { useForm } from "rc-field-form";
import SheetRow from "./SheetRowChildMultistage.jsx";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const SheetJobCardCylinderMultistage = ({
  currentCylinderData,
  multiview,
  jobCard,
  isSingleCylinder,
  unitData,
  units,
  isValidState = false,
  jobId,
  acceptedSolution,
  reFetchToggle,
  isSolutionChanged,
  cylinderViewData
}) => {
  const divRef = useRef();
  const [width, setWidth] = useState(0);
  const [columnData, setColumnData] = useState();
  const [widthChange, setWidthChange] = useState();
  const [reFetch, setReFetch] = useState(false);
  const [data, setData] = useState([]);
  const [key, setKey] = useState(0);
  const [cylinderData, setCylinderData] = useState()
  useEffect(() => {
    if (reFetchToggle) reFetchToggle();
  }, [reFetch]);
  useEffect(() => {
  }, [width, cylinderData]);
  useEffect(() => {
    if (!units) {
      setCylinderData(currentCylinderData);
      return;
    }
    const tempCylinderData = { ...currentCylinderData, units };
    setCylinderData(tempCylinderData)
  }, [])
  useEffect(() => {
    if (!units) {
      setCylinderData(currentCylinderData);
      return;
    }
    const tempCylinderData = { ...currentCylinderData, units };
    setCylinderData(tempCylinderData)
},[currentCylinderData])
  useEffect(() => {
    setKey((prevKey) => prevKey + 1); // Increment key to force re-render
  }, [acceptedSolution]);
  useEffect(() => {
    
  }, [units]);
  const transformPatternData = (patterns, unitData) => {
    if (!patterns) return;
    if (!isSingleCylinder) {
      let maxDeckle = 0;
      patterns?.map((row) => {
        const deckle =
          row?.reel_size * CoversionFactorUnitsToCM[row?.units?.reel_size] -
          (row?.left_edge_trim + row?.right_edge_trim) *
            CoversionFactorUnitsToCM[row?.units?.right_edge_trim];

        if (maxDeckle < deckle) maxDeckle = deckle;
      });
      return patterns?.map((row, rowIndex) => {
        const deckle_length =
          row?.reel_size * CoversionFactorUnitsToCM[row?.units?.reel_size] -
          (row?.left_edge_trim + row?.right_edge_trim) *
            CoversionFactorUnitsToCM[row?.units?.right_edge_trim];
        let sheetArray = [];
        let maxWidth = 0;
        maxWidth = row?.cutting_partitions?.reduce((maxWidth, item) => {
            return Math.max(maxWidth, item?.size);
        }, 0) || 0;
      
        if (!row?.partitions_position) {
          sheetArray = row?.cutting_partitions.map((item, idx) => {
            return { ...item, originalIndex: idx, combinationNumber: rowIndex };
          });
          if (row?.trim_loss) {
            sheetArray.push({
              item_type: "trimloss",
              trim_loss: row?.trim_loss,
              size: row?.trim_loss,
              originalIndex: row?.cutting_partitions.length,
              combinationNumber: rowIndex,
            });
          }
        } else {
          sheetArray = row?.partitions_position
            .map((idx) => {
              if (idx === row?.cutting_partitions.length && row?.trim_loss) {
                return {
                  item_type: "trimloss",
                  trim_loss: row?.trim_loss,
                  size: row?.trim_loss,
                  originalIndex: row?.cutting_partitions.length,
                  combinationNumber: rowIndex,
                };
              }
              return {
                ...row.cutting_partitions[idx],
                originalIndex: idx,
                combinationNumber: rowIndex,
              };
            })
            .filter(
              (item) => !(!row?.trim_loss && item?.item_type === "trimloss")
            );
        }

        const columns = sheetArray?.map((columnData) => {
          return {
            ...columnData,
            percentWidth: (columnData?.size * CoversionFactorUnitsToCM[row?.units?.size] / maxDeckle) * 100,
          };
        });

        const totalWeight = row?.total_weight - row?.cancelled_weight;

        return {
          columns,
          weight: totalWeight,
          row_meta: {
            percentTrimLossWidth: (row?.trim_loss / deckle_length) * 100,
            deadline: row?.deadline,
            repeated: row?.repeated,
            length: row?.length,
            trim_loss: row?.trim_loss,
            deckle_length: deckle_length,
            trim_loss_width: row?.trim_loss_width,
            trim_loss_area: row?.trim_loss_area,
            trim_loss_weight: row?.trim_loss_weight,
            totalWeight,
            total_weight: row?.total_weight,
            cancelled_weight: row?.cancelled_weight,
            units: row?.units,
            maxDeckle: maxDeckle,
            max_width: maxWidth,
            allowRearranging: row?.allow_sheet_rearranging !== false
          },
        };
      });
    }
    const temp = [];
    const row = patterns;
    const deckle_length = row?.reel_width  * CoversionFactorUnitsToCM[row?.units?.reel_width] - (row?.left_edge_trim + row?.right_edge_trim) * CoversionFactorUnitsToCM[row?.units?.right_edge_trim];
    const columns = row?.intermediate_reels_data.map((columnData) => {
      const percentWidth = (columnData?.size* CoversionFactorUnitsToCM[row?.units?.size] / deckle_length) * 100;
      return {
        ...columnData,
        percentWidth,
        type: columnData?.item_type,
        size: columnData?.size,
        width: columnData?.order_width,
        order_width: columnData?.order_width,
        length_data : row?.length,
      };
    });

    const totalWeight = row?.intermediate_reels_data.reduce(
      (acc, columnData) => {
        if (columnData?.type === "sheet") {
          return acc + columnData?.ir_weight;
        } else {
          return acc + columnData?.weight;
        }
      },
      0
    );

    temp.push({
      columns,
      row_meta: {
        percentTrimLossWidth: (row?.trim_loss / deckle_length) * 100,
        deadline: row?.deadline,
        repeated: row?.repeated,
        length: row?.length,
        deckle_length: deckle_length,
        trim_loss: row?.trim_loss,
        trim_loss_width: row?.trim_loss_width,
        trim_loss_area: row?.trim_loss_area,
        trim_loss_weight: row?.trim_loss_weight,
        totalWeight,
        units: { ...units, length: units?.order_length },
      },
    });
    return temp;
  };


  useEffect(() => {
   cylinderData && setData(transformPatternData(cylinderData, unitData));
  }, [jobCard, cylinderData, width]);
  useEffect(() => {
    // console.log(data);
  }, [data]);

  useLayoutEffect(() => {
    if (divRef.current) {
      const _width = divRef?.current.offsetWidth;
      _width - (!isSingleCylinder ? 210 : 0) > 0 && setWidth(_width - (!isSingleCylinder ? 210 : 0));
      // console.log(_width, width);
    }
  }, [currentCylinderData,
    multiview,
    jobCard,
    isSingleCylinder,
    unitData,
    units,
    jobId,
    acceptedSolution,
    reFetchToggle]);

  // useEffect(() => {
  //   if (width && data && data.length) {
  //     const columnDataList = setColumnData(columnDataList);
  //   }
  // }, [width, isValidState]);

  return  (
    <div ref={divRef} key={JSON.stringify(currentCylinderData)} >
      {data?.map((row, index) => {
        // let height =
        //   ((row.row_meta.length *
        //     CoversionFactorUnitsToCM[row.row_meta.units.length]) /
        //     row.row_meta.maxDeckle) *
        //   width;
        // height =
        //   height +
        //   (((-row.row_meta.max_width + row.row_meta.length) * width) /
        //     row.row_meta.max_width) *
        //     0.5;
        // if (height > 120) height = 120;
        const pixelFactor = width / row?.row_meta.maxDeckle;
        let height =
          (row?.row_meta.max_width *
            CoversionFactorUnitsToCM[row?.row_meta?.units?.size] +
            (row?.row_meta.length *
              CoversionFactorUnitsToCM[row?.row_meta?.units?.length] -
              row?.row_meta.max_width *
                CoversionFactorUnitsToCM[row?.row_meta?.units?.size]) *
              0.5) *
          pixelFactor;

        return (
          <SheetRow
            key={index}
            row={row}
            index={index}
            isValidState={isValidState}
            width={width}
            height={height}
            cylinderData={cylinderData}
            jobId={jobId}
            isSingleCylinder={isSingleCylinder}
            acceptedSolution={acceptedSolution}
            reFetchToggle={() => setReFetch(!reFetch)}
            cylinderViewData={cylinderViewData}
          />
        );
      })}
    </div>
  ) 
};

export default SheetJobCardCylinderMultistage;
